import { useState, type FormEvent } from "react";
import { Button } from "@/components/ui/button";
import { Field, Input } from "@/components/ui/field";
import { Alert } from "@/components/ui/alert";
import { BrandMark } from "@/components/brand-mark";
import { useLogin } from "@/lib/session";
import { ApiError } from "@/lib/api-client";

export function LoginPage() {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const login = useLogin();

    function handleSubmit(event: FormEvent) {
        event.preventDefault();
        login.mutate({ username, password });
    }

    // Thông báo của server đã kèm thời gian chờ thật ("Thử lại sau 5 phút"),
    // đừng thay bằng câu chung chung.
    const message =
        login.error instanceof ApiError
            ? login.error.message
            : login.error
              ? "Đăng nhập thất bại"
              : null;
    const locked = login.error instanceof ApiError && login.error.status === 429;

    return (
        <div className="flex min-h-full items-center justify-center px-4 py-12">
            <div className="w-full max-w-sm">
                <div className="mb-6 flex flex-col items-center text-center">
                    <div className="mb-3 flex size-11 items-center justify-center rounded-xl bg-brand p-2.5 text-white">
                        <BrandMark />
                    </div>
                    <h1 className="text-xl font-semibold text-ink">ZSchedule</h1>
                    <p className="mt-1 text-sm text-ink-muted">Gửi tin theo lịch tới các nhóm Zalo</p>
                </div>

                <form
                    onSubmit={handleSubmit}
                    className="space-y-4 rounded-xl border border-line bg-surface p-6 shadow-sm"
                >
                    {message && <Alert tone={locked ? "warning" : "danger"}>{message}</Alert>}

                    <Field label="Tên đăng nhập" htmlFor="username">
                        <Input
                            id="username"
                            type="text"
                            autoComplete="username"
                            autoCapitalize="none"
                            spellCheck={false}
                            required
                            value={username}
                            onChange={(event) => setUsername(event.target.value)}
                        />
                    </Field>

                    <Field label="Mật khẩu" htmlFor="password">
                        <Input
                            id="password"
                            type="password"
                            autoComplete="current-password"
                            required
                            value={password}
                            onChange={(event) => setPassword(event.target.value)}
                        />
                    </Field>

                    <Button type="submit" className="w-full" loading={login.isPending}>
                        Đăng nhập
                    </Button>
                </form>
            </div>
        </div>
    );
}
